//https://swiperjs.com/
import Swiper from 'swiper';
import {Mousewheel, A11y, Keyboard, FreeMode} from 'swiper/modules';

//import swiper styles
import 'swiper/css/bundle';

const allWinesCarousel = document.querySelector('.wine-list-carousel');
const initialSlide = Math.floor(parseInt(allWinesCarousel.dataset.length) / 2) || 0;

const allWines = new Swiper(allWinesCarousel, {
    modules: [FreeMode, Mousewheel, A11y, Keyboard],
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    loop: false,
    freeMode: true,
    mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
    },
    keyboard: {
        enabled: true,
        onlyInViewport: true,
    },
    a11y: {
        enabled: true,
        containerRoleDescriptionMessage: 'carousel',
        itemRoleDescriptionMessage: 'slide',
        slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
    },
});